import { Link } from 'react-router-dom';
import { useLang } from '../context/LangContext';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer>
      <div className="footer-top">
        <div className="footer-links">
          <div className="footer-col">
            <h4>{t('footer.legal.title')}</h4>
            <Link to="/legal/legales-generales">{t('footer.legal.general')}</Link>
            <Link to="/legal/privacidad">{t('footer.legal.privacy')}</Link>
            <Link to="/legal/terminos-condiciones">{t('footer.legal.terms')}</Link>
            <Link to="/legal/cookies">{t('footer.legal.cookies')}</Link>
            <Link to="/legal/envios-devoluciones">{t('footer.legal.shipping')}</Link>
          </div>
          <div className="footer-col">
            <h4>{t('footer.info.title')}</h4>
            <Link to="/centro-de-ayuda">{t('footer.info.help')}</Link>
            <Link to="/mercados-emergentes">{t('footer.info.markets')}</Link>
            <Link to="/legal/codigo-etica">{t('footer.info.ethics')}</Link>
            <a href="#">{t('footer.info.resources')}</a>
            <a href="#">{t('footer.info.external')}</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="footer-copy">{t('footer.copy')}</p>
        <div className="footer-attrs">
          <span className="footer-attr">{t('footer.attr.accessible')}</span>
          <span className="footer-attr">{t('footer.attr.efficient')}</span>
          <span className="footer-attr">{t('footer.attr.human')}</span>
        </div>
      </div>
    </footer>
  );
}
